// src/social/hashtags.js
// Hashtag templates for social media posts

export const propertyHashtags = {
  "best-star-inn-montebello": ["#BestStarInn", "#BestStarInnMontebello", "#MontebelloHotel"],
  "hotel-olyver-los-angeles": ["#HotelOlyver", "#HotelOlyverLA", "#LosAngelesHotel"],
  "palm-inn-motel-rosemead": ["#PalmInnMotel", "#PalmInnRosemead", "#RosemeadHotel"],
  "fountain-inn-motel-alhambra": ["#FountainInnMotel", "#FountainInnAlhambra", "#AlhambraHotel"],
  "star-light-inn-los-angeles": ["#StarLightInn", "#StarLightInnLA", "#LosAngelesHotel"],
  "garden-inn-motel-sangabriel": ["#GardenInnMotel", "#GardenInnSG", "#SanGabrielHotel"],
  "hi-way-host-motel-pasadena": ["#HiWayHostMotel", "#HiWayHostPasadena", "#PasadenaHotel"],
  "plaza-inn-motel-rosemead": ["#PlazaInnMotel", "#PlazaInnRosemead", "#RosemeadHotel"],
  "playa-inn-long-beach": ["#PlayaInnLongBeach", "#PlayaInn", "#LongBeachHotel"]
};

export const locationHashtags = {
  "Montebello": ["#Montebello", "#MontebelloCA", "#MontebelloCalifornia", "#MontebelloLife"],
  "Rosemead": ["#Rosemead", "#RosemeadCA", "#RosemeadCalifornia", "#RosemeadLife"],
  "San Gabriel": ["#SanGabriel", "#SanGabrielCA", "#SanGabrielCalifornia", "#SanGabrielValley"],
  "Alhambra": ["#Alhambra", "#AlhambraCA", "#AlhambraCalifornia", "#AlhambraLife"],
  "Pasadena": ["#Pasadena", "#PasadenaCA", "#PasadenaCalifornia", "#PasadenaLife"],
  "Long Beach": ["#LongBeach", "#LongBeachCA", "#LongBeachCalifornia", "#LongBeachLife"],
  "Los Angeles": ["#LosAngeles", "#LosAngelesCA", "#LosAngelesCalifornia", "#LALife", "#ExploreLA"],
  "El Monte": ["#ElMonte", "#ElMonteCA", "#ElMonteCalifornia"],
  "Baldwin Park": ["#BaldwinPark", "#BaldwinParkCA", "#BaldwinParkCalifornia"],
  "West Covina": ["#WestCovina", "#WestCovinaCA", "#WestCovinaCalifornia"],
  "Arcadia": ["#Arcadia", "#ArcadiaCA", "#ArcadiaCalifornia"],
  "Temple City": ["#TempleCity", "#TempleCityCA", "#TempleCityCalifornia"]
};

export const industryHashtags = [
  "#Hotel", "#Motel", "#Lodging", "#Accommodation", "#Hospitality",
  "#Travel", "#TravelUSA", "#USTravel", "#CaliforniaTravel",
  "#Vacation", "#Staycation", "#Getaway", "#WeekendGetaway",
  "#BusinessTravel", "#RoadTrip", "#FamilyTravel", "#CoupleTravel"
];

export const travelHashtags = [
  "#TravelGram", "#TravelPhotography", "#Wanderlust", "#InstaTravel",
  "#TravelDiaries", "#ExploreMore", "#TravelLife", "#TravelAddict",
  "#BucketList", "#TravelGoals", "#TravelBlogger", "#TravelBloggerLife"
];

export const comfortHashtags = [
  "#ComfortStay", "#CozyStay", "#RelaxAndUnwind", "#RestfulNight",
  "#GoodNightSleep", "#HomeAwayFromHome", "#ComfortableRooms",
  "#CleanRooms", "#ModernRooms", "#AffordableStay", "#ValueForMoney"
];

export const bookingHashtags = [
  "#BookDirect", "#BookNow", "#BookEarly", "#SaveMore",
  "#BestRates", "#HotelDeals", "#LastMinuteDeals", "#SpecialOffer",
  "#DiscountCode", "#PromoCode", "#FreeCancellation", "#FlexibleBooking"
];

export const seasonalHashtags = {
  "Spring": ["#Spring", "#SpringBreak", "#SpringTravel", "#SpringGetaway"],
  "Summer": ["#Summer", "#SummerTravel", "#SummerVibes", "#SummerGetaway", "#PoolTime"],
  "Fall": ["#Fall", "#FallFoliage", "#AutumnTravel", "#FallGetaway", "#CozyFall"],
  "Winter": ["#Winter", "#WinterTravel", "#WinterGetaway", "#HolidayTravel", "#NewYear"]
};

export const businessHashtags = [
  "#BusinessTravel", "#CorporateTravel", "#WorkTrip", "#Conference",
  "#Meeting", "#Convention", "#BusinessHotel", "#WorkFromHotel"
];

export const companyHashtags = ["@TheWesternTech"];

// Function to generate hashtags for a post
export function generateHashtags(property, postType, city, season) {
  const propertySlug = property.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-');
  
  const hashtags = [];
  
  // Add property-specific hashtags
  if (propertyHashtags[propertySlug]) {
    hashtags.push(...propertyHashtags[propertySlug].slice(0, 2));
  }
  
  // Add location hashtags
  if (city && locationHashtags[city]) {
    hashtags.push(...locationHashtags[city].slice(0, 1));
  }
  
  // Add industry hashtags (only 1)
  hashtags.push(...industryHashtags.slice(0, 1));
  
  // Add type-specific hashtags
  if (postType === 'ROOM' || postType === 'LOBBY') {
    hashtags.push(...comfortHashtags.slice(0, 1));
  }
  
  if (postType === 'OFFER') {
    hashtags.push(...bookingHashtags.slice(0, 1));
  }
  
  if (postType === 'ATTRACTION') {
    hashtags.push("#Explore" + (city || "Local").replace(/\s+/g, ''));
  }
  
  // Add seasonal hashtags
  if (season && seasonalHashtags[season]) {
    hashtags.push(...seasonalHashtags[season].slice(0, 1));
  }
  
  // Remove duplicates and limit to 5 (Facebook recommends 3-5 max)
  const unique = [...new Set(hashtags)];
  return unique.slice(0, 5).join(' ');
}
